<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
<!--      <a-form-model-item :label="$t('活动记录.活动类型')" prop="activityType" >-->
<!--        <a-select :placeholder="$t('通用.输入.请选择')+$t('活动记录.活动类型')" v-model="form.activityType" allowClear>-->
<!--          <a-select-option v-for="(item, index) in activityTypeList" :value="item.id"-->
<!--                           :key="index">-->
<!--            {{ item.name }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->

      <a-form-model-item prop="activityName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.活动名称')}}<template slot="title">{{$t('询价记录.活动名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.activityName" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('询价记录.活动名称')" />
      </a-form-model-item>

      <a-form-model-item prop="startTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.开始时间')}}<template slot="title">{{$t('询价记录.开始时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" valueFormat='YYYY-MM-DD HH:mm:ss' show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.结束时间')}}<template slot="title">{{$t('询价记录.结束时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" valueFormat="YYYY-MM-DD HH:mm:ss" show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="deliveryTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.最晚交期')}}<template slot="title">{{$t('询价记录.最晚交期')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.deliveryTime" valueFormat="YYYY-MM-DD HH:mm:ss" show-time allow-clear/>
      </a-form-model-item>


<!--      <a-form-model-item prop="payBond" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('询价记录.是否需要缴纳保证金')}}<template slot="title">{{$t('询价记录.是否需要缴纳保证金')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.payBond"  :placeholder="$t('通用.输入.请输入')+$t('询价记录.是否需要缴纳保证金')" />-->
<!--      </a-form-model-item>-->



      <a-form-model-item class="margin-bottom-10" :label="$t('询价记录.是否需要缴纳保证金')"
                         prop="payBond">
        <a-radio-group v-model="form.payBond" button-style="solid">
          <a-radio-button  :value="0" :key="0">否</a-radio-button>
          <a-radio-button  :value="1" :key="1"> 是</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <span v-if="form.payBond==1">
         <a-form-model-item prop="bondMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.保证金金额')}}<template slot="title">{{$t('询价记录.保证金金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.bondMoney"  :placeholder="$t('通用.输入.请输入')+$t('询价记录.保证金金额')" @change="limitBondMoney()"/>
      </a-form-model-item>
      </span>

      <a-form-model-item prop="endMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.底价')}}<template slot="title">{{$t('询价记录.底价')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.endMoney"  :placeholder="$t('通用.输入.请输入')+$t('询价记录.底价')" @change="limitEndMoney()"/>
      </a-form-model-item>

      <a-form-model-item prop="isSell" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.是否上架')}}<template slot="title">{{$t('询价记录.是否上架')}}</template>
          </a-tooltip>
        </span>
        <a-select style="width: 100%" v-model="form.isSell" :placeholder="$t('通用.输入.请选择')+$t('询价记录.是否上架')">
          <a-select-option  :value="0" :key="0">否</a-select-option>
          <a-select-option  :value="1" :key="1">是</a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item prop="payType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.付款方式')}}<template slot="title">{{$t('询价记录.付款方式')}}</template>
          </a-tooltip>
        </span>
        <a-select style="width: 100%" v-model="form.payType" :placeholder="$t('通用.输入.请选择')+$t('询价记录.付款方式')">
          <a-select-option  :value="10" :key="10">现金支付</a-select-option>
          <a-select-option  :value="20" :key="20">线上转账</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="expressType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('询价记录.物流方式')}}<template slot="title">{{$t('询价记录.物流方式')}}</template>
          </a-tooltip>
        </span>
        <a-select style="width: 100%" v-model="form.expressType" :placeholder="$t('通用.输入.请选择')+$t('询价记录.物流方式')">
          <a-select-option  :value="10" :key="10">同城快运</a-select-option>
        </a-select>
      </a-form-model-item>




      <a-form-model-item :label="$t('通用.文本.选择商品')" >
        <div @click="openProdSelect" style="width: 100px">
          <a-button type="dashed" @click="openProdSelect" danger>
            <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
          </a-button>
        </div>
      </a-form-model-item>
      <a-table v-if="this.form.goodsList.length>0"
               :loading="goodsLoading"

               rowKey="id"
               :size="tableSize"
               :columns="goodsColumns"
               :data-source="form.goodsList"
               :pagination="false"
               :bordered="tableBordered">
<!--        <span slot="createTime" slot-scope="text, record">-->
<!--          {{ parseTime(record.createTime) }}-->
<!--        </span>-->
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;"  alt="none"/>
            </div>
          </template>

<!--        <span slot="categoryId" slot-scope="text, record">-->
<!--            {{getCategoryNameById(record.categoryId)}}-->
<!--        </span>-->
<!--        <span slot="brandId" slot-scope="text, record">-->
<!--             {{getBrandNameById(record.brandId)}}-->
<!--          </span>-->
          <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
          </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleGoodsDelete(record.id)">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>



      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <checkbox-goods-select-form ref="CheckboxGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></checkbox-goods-select-form>
  </a-drawer>
</template>

<script>

import { getActivityXunjia, addActivityXunjia, updateActivityXunjia } from '@/api/activityXunjia/activityXunjia'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateRdStr, uploadObject, uploadOss} from "@/api/tool/oss";
import {allBrand} from "@/api/goods/brand";
import {listCategory} from "@/api/goods/category";
import Editor from "@/components/Editor/Editor";
import {translation} from "@/api/tool/common";
import CheckboxGoodsSelectForm from "@/views/activityXunjia/activityXunjia/modules/CheckboxSelectForm";
import { tableMixin } from '@/store/table-mixin'
import {listType} from "@/api/activity/type";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    CheckboxGoodsSelectForm,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      goodsLoading: false,
      goodsColumns: [
        {
          title: this.$t('商品.商品编号'),
          dataIndex: 'id',
          width: 200,
          fixed: 'left',
        },
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
          width: 200,
          fixed: 'left',
        },
        // {
        //   title: this.$t('商品.包装单位'),
        //   width: 60,
        //   dataIndex: 'unit',
        // },
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'picture',
          width: 60,
          scopedSlots: {customRender: 'picture'},
        },
        // {
        //   title: this.$t('商品.商品分类'),
        //   dataIndex: 'categoryId',
        //   width: 60,
        //   scopedSlots: {customRender: 'categoryId'},
        // },
        // {
        //   title: this.$t('商品.品牌'),
        //   dataIndex: 'brandId',
        //   width: 50,
        //   scopedSlots: {customRender: 'brandId'},
        // },
        // {
        //   title: this.$t('商品.售卖开始时间'),
        //   width: 100,
        //   dataIndex: 'saleStartTime',
        // },
        // {
        //   title: this.$t('商品.售卖结束时间'),
        //   width: 100,
        //   dataIndex: 'saleEndTime',
        // },
        // {
        //   title: this.$t('商品.市场价'),
        //   width: 50,
        //   dataIndex: 'marketPrice',
        // },
        // {
        //   title: this.$t('商品.商品价'),
        //   width: 50,
        //   dataIndex: 'price',
        // },
        {
          title: this.$t('商品.商品状态'),
          dataIndex: 'status',
          width: 60,
          scopedSlots: {customRender: 'status'},
        },

        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 70,
          scopedSlots: {customRender: 'operation'},
        }
      ],
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('活动记录.活动名称'),
          dataIndex: 'activityName',
          scopedSlots: { customRender: 'activityName' },
          key: 'activityName'
        }, {
          title: this.$t('活动记录.分享文案'),
          dataIndex: 'posterTxt',
          scopedSlots: { customRender: 'posterTxt' },
          key: 'posterTxt'
        }, {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          width: 20,
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      activityTypeList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        goodsList:[],
        localeList: [],

        id: null,

        activityName: null,

        startTime: null,

        endTime: null,

        deliveryTime: null,

        payBond: null,

        bondMoney: null,

        endMoney: null,

        isSell: null,

        payType: null,

        expressType: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        activityName: [
          { required: true, message: this.$t('询价记录.活动名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('询价记录.开始时间')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('询价记录.结束时间')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        deliveryTime: [
          { required: true, message: this.$t('询价记录.最晚交期')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        payBond: [
          { required: true, message: this.$t('询价记录.是否需要缴纳保证金')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        bondMoney: [
          { required: true, message: this.$t('询价记录.保证金金额')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        endMoney: [
          { required: true, message: this.$t('询价记录.底价')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        isSell: [
          { required: true, message: this.$t('询价记录.是否上架')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        payType: [
          { required: true, message: this.$t('询价记录.支付方式')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
        expressType: [
          { required: true, message: this.$t('询价记录.物流方式')+this.$t('通用.文本.不能为空'), trigger: 'change' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    this.getAtvCateList();
    this.getBrandList();
    this.getCateList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        localeList: [],
        goodsList:[],
        id: null,
        activityName: null,
        startTime: null,
        endTime: null,
        deliveryTime: null,
        payBond: null,
        bondMoney: null,
        endMoney: null,
        isSell: null,
        payType: null,
        expressType: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }

    },
    limitMaxNum(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.limitNum = val
    },
    handleGoodsDelete(key) {
      const dataSource = [...this.form.goodsList];
      this.form.goodsList = dataSource.filter(item => item.id !== key);
    },
    /*text 要翻译的字段*/
    getTranslation(record) {
      if (!this.form.activityName && !this.form.posterTxt) {
        return;
      }
      let data = {"text": this.form.activityName, "locale": record.locale, "time": generateRdStr()};
      translation(data).then(response => {
        record.activityName = response.data
      })
      let data2 = {"text": this.form.posterTxt, "locale": record.locale, "time": generateRdStr()};
      translation(data2).then(response => {
        record.posterTxt = response.data
      })
    },
    limitSort(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },

    limitMaxBuyNum() {
      // console.log(i);
      let val = this.form.maxBuyNum.replace(/^\D*([0-9]\d*)?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<0) {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.maxBuyNum = val
    },

    getAtvCateList() {
      listType({status: 1}).then(response => {

        let activeList = response.data;
        let activityTypeList = [];
        for (var i=0;i<activeList.length;i++) {
          if (activeList[i].linkType == '70' || activeList[i].linkType == '80'
            || activeList[i].linkType == '90'|| activeList[i].linkType == '100'
            || activeList[i].linkType == '110' || activeList[i].linkType == '120'){
            activityTypeList.push(activeList[i]) ;
          }
        }
        this.activityTypeList = activityTypeList;
      })
    },

    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },

    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
        const cate = { id: "0", categoryName: this.$t('通用.文本.根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','pid')
        this.cateOptions.push(cate)
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    indexGoodsModalSelect(records) {
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
    },
    openProdSelect() {
      this.$refs.CheckboxGoodsSelectForm.openGoods(undefined, this.form.goodsList, 10);
    },


    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'posterPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.initLocale()
      this.formTitle = this.$t('通用.文本.添加')
    },
    validatorLocaleName() {
      let errorMessage = "";
      var localeList = this.form.localeList;
      let localeEnum = this.customDict.LocaleEnum;
      localeList.forEach(e=>{
        if (!e.activityName) {
          let localeName = localeEnum.find(locale=>locale.type===e.locale).name;
          errorMessage += localeName+this.$t('活动记录.活动名称') + this.$t('通用.文本.不能为空')+';';
        }
      })
      if (errorMessage) {
        this.errorMessage = errorMessage;
        return false;
      }
      this.errorMessage = "";
      return true;
    },
    initLocale() {
      //获取全局配置的语言
      const sysLangList = globalThis.$openLangList;
      //初始化多语言
      let localeList = [];
      let i = 1;
      this.customDict.LocaleEnum.forEach(e => {
        if(sysLangList.includes(e.type)){
          localeList.push({"id": i, "locale": e.type, 'name': ''})
          i++;
        }
      })
      this.form.localeList = localeList;
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivityXunjia({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      // let localeValid = this.validatorLocaleName();
      // if (!localeValid) {
      //   return false;
      // }
      if (this.form.goodsList.length === 0) {
        this.$message.error('请选择商品', 3)
        return false;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateActivityXunjia(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addActivityXunjia(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      });
    },

    limitBondMoney() {
      let val = this.form.bondMoney.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.bondMoney = val
    },
    limitEndMoney() {
      let val = this.form.endMoney.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.endMoney = val
    },

  }
}
</script>
